import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import loginReducer1 from "./loginReducer";
import specialityListReducer from "./specialityListReducer";
import doctordetailsReducer from "./doctordetailsReducer";
import treatmentListReducer from "./treatmentListReducer";
import bookAppoinmentReducer1 from "./bookAppoinmentReducer";
import doctorListingReducer from "./doctorListingReducer";
import clientDetailsReducer from "./clientDetailsReducer";
import consultationReducer from "./consultationReducer";
import appointmentHistoryReducer from "./appointmentHistoryReducer";
import modalReducer from "./modalReducer";
import InterbranchAdminreducer from "./InterbranchAdminreducer";
import doctorappointmenthistoryReducer from "./doctorappointmenthistoryReducer";
import doctorAcceptRejectReducer from "./doctorAcceptRejectReducer";
import presctiptionFormReducer from "./prescriptionFormreducer";
import interBranchCoordinatorReducer from "./interBranchCoordinatorReducer";
import themereducer from "./themereducer";
import managePrescription from "./managePrescription";
import rpmreducer from "./rpmReducer";
import patientDashboardReducer from "./patientDashboardReducer";
import requestDetails from "./requestDetails";
import departmentManagementReducer from "./departmentManagementReducer";

const persistConfig = {
  key: "user",
  storage,
  whitelist: ["user", "login"],
};
const persistConfig1 = {
  key: "apmnt",
  storage,
  whitelist: ["appoinment_form", "selected_states"],
};

const loginReducer = persistReducer(persistConfig, loginReducer1);
const bookAppoinmentReducer = persistReducer(
  persistConfig1,
  bookAppoinmentReducer1
);

export default combineReducers({
  login: loginReducer,
  specialityList: specialityListReducer,
  doctorDetail: doctordetailsReducer,
  treatmentList: treatmentListReducer,
  bookAppoinment: bookAppoinmentReducer,
  doctorListing: doctorListingReducer,
  clientDetails: clientDetailsReducer,
  consultationDetails: consultationReducer,
  appointmentHistory: appointmentHistoryReducer,
  doctorAppointmentHistory: doctorappointmenthistoryReducer,
  doctorAcceptReject: doctorAcceptRejectReducer,
  interbranchModal: modalReducer,
  interbranchAdmin: InterbranchAdminreducer,
  presctiptionFormReducer: presctiptionFormReducer,
  interBranchCoordinator: interBranchCoordinatorReducer,
  theme: themereducer,
  managePrescription: managePrescription,
  rpmreducer: rpmreducer,
  patientDashboardReducer: patientDashboardReducer,
  requestDetails:requestDetails,
  departmentManagement: departmentManagementReducer,
});
